import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import ConfirmProfileComponent from './ConfirmProfile.component';
import { RootState } from 'src/reducers/RootReducer';
import {
  ConfirmProfileProps
} from 'src/modules/project/partials/project-formalization/partials/confirm-profile/ConfirmProfile.component';
import Person from 'src/entities/Person';
import { getPhysicalPerson, GetPhysicalPersonAction } from 'src/actions/physical-person/get/GetPhysicalPerson.actions';
import JuridicalPerson from 'src/entities/JuridicalPerson';
import PhysicalPerson from 'src/entities/PhysicalPerson';
import {
  getJuridicalPerson,
  GetJuridicalPersonAction
} from 'src/actions/juridical-person/get/GetJuridicalPerson.actions';
import { history } from 'src/store';
import Investment from 'src/entities/Investment';

interface StateProps {
  defaultProfile: Person;
  juridicalPerson?: JuridicalPerson;
  physicalPerson?: PhysicalPerson;
}

interface DispatchProps {
  getPhysicalPerson: (physicalPersonId: number) => Promise<GetPhysicalPersonAction>;
  getJuridicalPerson: (juridicalPersonId: number) => Promise<GetJuridicalPersonAction>;
}

interface Props extends StateProps, DispatchProps {
  person: Person;
  projectId: number;
  investment: Investment;

  setInvestment(investment: Investment, step: string): void;

  setStep(step: string): void;
}

class ConfirmProfileContainer extends React.Component<Props> {

  public render(): React.ReactNode {
    return (
      (this.props.person.personType === 'physical' && this.props.physicalPerson) ||
      (this.props.person.personType === 'juridical' && this.props.juridicalPerson) ?
        <ConfirmProfileComponent {...this.getComponentProps()}/>
        : null
    );
  }

  public componentWillMount() {
    if (this.props.person.personType === 'physical') {
      this.props.getPhysicalPerson(this.props.person.id);
    } else {
      this.props.getJuridicalPerson(this.props.person.id);
    }
  }

  private handleConfirmProfile(): void {
    const investment: Investment = {
      ...this.props.investment!,
      status: 'Confirmed Profile',
    };
    this.props.setInvestment(investment, investment.status!);
  }

  private handleChangeProfile(): void {
    history.push('/mi-cuenta/perfil');
  }

  private getComponentProps(): ConfirmProfileProps {
    return {
      person: this.props.person,
      handleConfirmProfile: () => this.handleConfirmProfile(),
      handleChangeProfile: () => this.handleChangeProfile(),
      defaultProfile: this.ifDefault(this.props.person),
      activeProfile: true,
      physicalPerson: this.props.physicalPerson,
      juridicalPerson: this.props.juridicalPerson
    };
  }

  private ifDefault(person: Person): boolean {
    return (person.id === this.props.defaultProfile.id &&
      person.personType === this.props.defaultProfile.personType);
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  getPhysicalPerson: (physicalPersonId: number): Promise<GetPhysicalPersonAction> => (
    dispatch(getPhysicalPerson(physicalPersonId))
  ),
  getJuridicalPerson: (juridicalPersonId: number): Promise<GetJuridicalPersonAction> => (
    dispatch(getJuridicalPerson(juridicalPersonId))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  defaultProfile: state.getUser.user!.defaultProfile,
  physicalPerson: state.getPhysicalPerson.physicalPerson,
  juridicalPerson: state.getJuridicalPerson.juridicalPerson,
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmProfileContainer);



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/confirm-profile/ConfirmProfile.container.tsx